import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();
  
  // Add a timeout to prevent infinite loading
  useEffect(() => {
    let timeout;
    
    if (loading) {
      timeout = setTimeout(() => {
        console.log("Loading timeout - redirecting to login");
        navigate('/login', { replace: true });
      }, 5000); // 5 second timeout
    }
    
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [loading, navigate]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading authentication status...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute; 